// src/pages/ResetPasswordComplete.js
import Header from 'components/Header';
import LogoHeader from "../../../components/LogoHeader";
import CustomButton from '../../../components/CustomButton';

const ResetPasswordComplete = () => {

  return (
    <div className='static md:fixed md:inset-0 bg-alu-base'>
      <div className='min-w-[22.625rem] static md:absolute md:top-1/2 left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2'>
        <LogoHeader view="talent" page="advanced"></LogoHeader>
        <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-[22.625rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6'>
          <Header title="パスワードの再設定が完了しました"></Header>
          <div className="flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6">
          
            <CustomButton onClick={() => window.close()}>
              閉じる
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordComplete;